
import './App.css';
import {Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Login from './components/Auth/Login';
import Forgot from './components/Auth/Forgot';
import TwoFa from './components/Auth/TwoFa';
import Method from './components/Auth/Method';
import ResetPass from './components/Auth/ResetPass';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import Dashboard from './components/Screen/Dashboard';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import { Typography } from '@mui/material';
import Create from './components/Screen/Create';
import BackToTopButton from './components/Screen/BackToTopButton';


const theme = createTheme({
    overrides: {
        MuiCssBaseline: {
            "@global": {
                html: {
                    backgroundColor: "white",
                },
            },
        },
        MuiButton: {
            primary: {
                color: "white",
            },
        },
    },
    typography: {
        button: {
            textTransform: "none",
            color: "white",
        },
    },
    palette: {
        primary: {
            // Purple and green play nicely together.
            main: "#c7a936",
            contrastText: "#fff",
            "&:hover": {
                contrastText: "#fff",
            },
            textDecoration: "none",
        },
    },
});
function App() {
  return (
    <ThemeProvider theme={theme}>
    <div style={{background:'#d7d9e1'}}>
<Router>
      <Routes>
      <Route exact path='/' element={<Login/>} />
      <Route exact path='/:id' element={<Dashboard/>} />
      <Route exact path='/create/:id' element={<Create/>} />
      <Route exact path='/login' element={<Login/>} />
      <Route exact path='/reset/:id' element={<ResetPass/>} />
      <Route exact path='/forgot' element={<Forgot/>} />
      <Route exact path='/2fa/:id' element={<TwoFa/>} />
      <Route exact path='/select/:id' element={<Method/>} />

    </Routes> 
    </Router>  
    </div>
           <BackToTopButton/> 
    </ThemeProvider>
  );
}

export default App;
